import SelectedIcon from './component'

export default SelectedIcon
